import {FormComponent} from "./form-component";

export class ComponentSettings {
    type: any;
    name: string;
    icon: string;
    implementedOptions?: string[] = [];
    implementedValidators?: string[] = [];
    allowsChildren?: boolean = false;
    allowsData?: boolean = false;
    description?: string;
    sample?: FormComponent;
}

export enum OptionsEnum {
    //for data
    appearance = 'appearance',
    defaultValue = 'defaultValue',
    readOnly = 'readOnly',
    //for style and ui from material
    help = 'help',
    hidden = 'hidden',
    hideLabel = 'hideLabel',
    isFitScreen = 'isFitScreen',
    colspan = 'colspan',
    gridGap = 'gridGap',
    gridCols = 'gridCols'
}

export enum ValidatorsEnum {
    required = 'required',
    max = 'max',
    min = 'min',
    maxlength = 'maxlength',
    minlength = 'minlength',
    pattern = 'pattern',
    dateInFuture = 'dateInFuture',
    dateInPast = 'dateInPast',
    email = 'email',
    integerNumber = 'integerNumber',
    twoDecimalNumber = 'twoDecimalNumber'
}

export class MyValidator {
    key: ValidatorsEnum | string;
    label: string;
    // value is either a number, a boolean(true/false) , '*' or '' (for strings)
    value: string;
    message: string;
    // any component type means '*'
    componentTypes: string;
}

// this is a an extension of the snapshot from DynamicFormValidationRegistryService.validatorMap with component type
export const PREDEFINED_VALIDATORS: MyValidator[] = [
    {key: ValidatorsEnum.required, label: 'Required',   value: 'true',   message: 'Field is required', componentTypes: '*'},
    {key: ValidatorsEnum.minlength, label: 'Min chars length', value: '3',   message: 'Minimum length of characters incorrect', componentTypes:'text-area,text-box'},
    {key: ValidatorsEnum.maxlength, label: 'Max chars length', value: '10', message: 'Maximum length of characters incorrect', componentTypes:'text-area,text-box'},
    {key: ValidatorsEnum.min, label: 'Min number',      value: '0',    message: 'Minimum amount is required', componentTypes:'monetary,number'},
    {key: ValidatorsEnum.max, label: 'Max number',      value: '100',  message: 'Maximum amount is required', componentTypes:'monetary,number'},
    {key: ValidatorsEnum.email, label: 'Email',         value: 'true', message: 'Valid email address required', componentTypes:'text-area,text-box'},
    {key: ValidatorsEnum.pattern, label: 'Pattern',     value: '*', message: 'Valid text matching the pattern required', componentTypes:'text-area,text-box'},
    {key: ValidatorsEnum.dateInPast, label: 'Date in past',          value: 'true', message: 'Date must be in the past', componentTypes:'calendar,date-time'},
    {key: ValidatorsEnum.dateInFuture, label: 'Date in future',       value: 'true', message: 'Date must be in the future', componentTypes:'calendar,date-time'},
    {key: ValidatorsEnum.integerNumber, label: 'Integer number',      value: 'true', message: 'Integer number required', componentTypes:'number'},
    {key: ValidatorsEnum.twoDecimalNumber, label: '2 decimal number', value: 'true', message: '2 decimal number required', componentTypes:'number'},
];

export class MyOption {
    key: string | OptionsEnum; // from OptionType.key
    value?: string;
    componentTypes?: string; // * or DATA
    valueType?: any;
    predefinedValues?: string[];
}

export const PREDEFINED_OPTIONS: MyOption[] = [
    {key: OptionsEnum.defaultValue, value: '', valueType: String, componentTypes: 'DATA'},
    {key: OptionsEnum.readOnly, value: 'true', valueType: Boolean, componentTypes: 'DATA'},
    {key: OptionsEnum.hidden, value: 'true', valueType: Boolean, componentTypes: 'DATA'},
    {key: OptionsEnum.isFitScreen, value: 'true', valueType: Boolean, componentTypes: '*'},
    {key: OptionsEnum.hideLabel, value: 'true', valueType: Boolean, componentTypes: '*'},
    {key: OptionsEnum.appearance, value: 'outline', valueType: Selection, componentTypes: '*', predefinedValues: ['outline', 'fill', 'legacy', 'standard']},
    {key: OptionsEnum.help, value: '', valueType: String, componentTypes: '*'},
    {key: OptionsEnum.colspan, value: '1', valueType: Number, componentTypes: '*', predefinedValues: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12']},
    {key: OptionsEnum.gridGap, value: '5', valueType: Number, componentTypes: 'group'},
    {key: OptionsEnum.gridCols, value: '2', valueType: Number, componentTypes: 'group'},
];

export let SESSION_DATA: string = 'DATA';
export let SESSION_COMPONENT: string = 'COMPONENT';
export let SESSION_EDITOR_ON: string = 'SESSION_EDITOR_ON';
